// frontend/src/components/announcements/AnnouncementBanner.jsx

import { useEffect, useState } from "react";
import { getActivePinnedAnnouncements } from "../../lib/api";
import { Icon } from "../Common";

// placement: "dashboard" → gated by showPinnedOnDashboard
//            "portal"    → gated by showPinnedInEmployeePortal
export default function AnnouncementBanner({ placement = "dashboard" }) {
  const [announcement, setAnnouncement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    getActivePinnedAnnouncements()
      .then((res) => {
        if (cancelled) return;
        // Respect the company's display toggle for this placement.
        const allowed =
          placement === "portal"
            ? res?.showPinnedInEmployeePortal !== false
            : res?.showPinnedOnDashboard !== false;
        if (allowed && res?.announcements?.length) {
          setAnnouncement(res.announcements[0]);
        }
      })
      .catch(() => {}) // Silently fail — announcements are optional
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [placement]);

  if (loading || !announcement || dismissed) return null;

  return (
    <div style={{
      background: "linear-gradient(135deg, rgba(139,92,246,0.12), rgba(99,102,241,0.06))",
      border: "1px solid rgba(139,92,246,0.25)",
      borderRadius: 12,
      padding: "14px 18px",
      marginBottom: 16,
      display: "flex",
      gap: 12,
      alignItems: "flex-start",
      position: "relative",
    }}>
      <div style={{ flexShrink: 0, color: "#a78bfa", paddingTop: 2 }}>
        <Icon name="megaphone" size={18} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: "#a78bfa", textTransform: "uppercase", letterSpacing: 1 }}>
          Announcement
        </div>
        <div style={{ fontSize: 15, fontWeight: 600, color: "var(--text)", marginTop: 4 }}>
          {announcement.title}
        </div>
        <div style={{
          fontSize: 13,
          color: "var(--text-muted)",
          marginTop: 4,
          whiteSpace: "pre-wrap",
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
        }}>
          {announcement.body}
        </div>
      </div>
      <button
        className="icon-btn"
        onClick={() => setDismissed(true)}
        style={{ flexShrink: 0 }}
        aria-label="Dismiss"
      >
        <Icon name="x" size={14} />
      </button>
    </div>
  );
}
